import { Injectable } from '@angular/core';
import { AbstractService } from '@sol/components';

export type PlaygroundThemeMode = 'light' | 'dark' | 'night' | 'high-contrast';

interface PlaygroundThemeModeState {
  current: PlaygroundThemeMode;
}

const STORAGE_KEY = 'playground-theme-mode';
const CLASS_BY_MODE: Record<PlaygroundThemeMode, string> = {
  light: 'theme-sol-light',
  dark: 'theme-sol-dark',
  night: 'theme-sol-night',
  'high-contrast': 'theme-sol-high-contrast',
};

@Injectable({ providedIn: 'root' })
export class PlaygroundThemeModeService extends AbstractService<PlaygroundThemeModeState> {
  constructor() {
    super({ current: 'dark' });
    const saved = (localStorage.getItem(STORAGE_KEY) as PlaygroundThemeMode | null) ?? 'dark';
    this.set(saved);
  }

  public set(mode: PlaygroundThemeMode): void {
    localStorage.setItem(STORAGE_KEY, mode);
    const root = document.documentElement;
    Object.values(CLASS_BY_MODE).forEach(cls => root.classList.remove(cls));
    root.classList.add(CLASS_BY_MODE[mode]);
    this.patch({ current: mode });
  }

  public current(): PlaygroundThemeMode {
    return this.state.current;
  }
}
